var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgCloseCircle = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 16 16",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M8 16c4.42 0 8-3.58 8-8s-3.58-8-8-8-8 3.58-8 8 3.58 8 8 8ZM4.077 5.9a.387.387 0 0 1 0-.548l1.278-1.275a.387.387 0 0 1 .548 0L8 6.194l2.1-2.117a.387.387 0 0 1 .548 0l1.275 1.278a.387.387 0 0 1 0 .548L9.806 8l2.117 2.1a.387.387 0 0 1 0 .548l-1.278 1.278a.387.387 0 0 1-.548 0L8 9.806l-2.1 2.117a.387.387 0 0 1-.548 0l-1.278-1.278a.387.387 0 0 1 0-.548L6.194 8 4.077 5.9Z"
})));

export default SvgCloseCircle;